import { useEffect } from "react";
import config from "../config";

/**
 * Hook to listen for profile picture updates
 * Triggers a refresh when profile picture changes
 */
export const useProfileRefresh = (callback) => {
  useEffect(() => {
    // Listen for storage changes (when profile is updated in another tab/window)
    const handleStorageChange = (e) => {
      if (e.key === "adminUserData") {
        const newData = JSON.parse(e.newValue);
        config.setUserData(newData);
        if (callback) callback(newData);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [callback]);
};

/**
 * Trigger profile refresh across all tabs/windows
 * Call this after updating profile picture
 */
export const triggerProfileRefresh = (userData) => {
  // Update config
  config.setUserData(userData);
  
  // Trigger storage event for other tabs
  const event = new StorageEvent("storage", {
    key: "adminUserData",
    newValue: JSON.stringify(userData),
    oldValue: localStorage.getItem("adminUserData"),
    storageArea: localStorage,
  });
  window.dispatchEvent(event);
};

